// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  socketUrl:'devchat.myqlout.com',
  // stripe_pk:'pk_test_51HcjDfIDD2jQaejEtqO4uSXeOgOSNZp4v4u5HmeOZzO2D2bg7wAzkv6xcFVAOSxCcnT2ApoIWUUK16yMEBxqYSDl00HwAcsrse',  //Our
  stripe_pk:'pk_test_51KE6XlJM0H8QRPJDA7yDCURjECTTj2ZEl5hvaHKHnsGUfvLWT7kQWkpQiNkN3po6AY6xzje1LaPVtL14M8m7PhWR00yu8N5RlL', //client
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
